<template>
  <section
    ref="$block"
    class="osk-home-blocks-selection"
  >
    <div class="osk-wrapper">
      <h2
        v-if="data.title"
        class="osk-home-blocks-selection__title"
      >
        {{ data.title }}
      </h2>

      <ul class="osk-home-blocks-selection__list">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="osk-home-blocks-selection__item"
        >
          <UikitProductCard
            :index="index"
            :product="item"
            chapter="product_collection"
            :chapter-id="data.id"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { PrimaryContentDTO, PrimaryPageProductDTO } from '~/restAPI/data-contracts';
import { AnalyticsEvents } from '~/types/analytics';

const props = defineProps<{
  data: PrimaryContentDTO
}>();

const $block = ref<ComponentPublicInstance>();

const { $addEvent } = useNuxtApp();
const isVisible = useElementVisibility($block);

const items = computed(() => (props.data.contentList ?? []) as PrimaryPageProductDTO[]);

const unwatch = watch(() => isVisible.value, (value) => {
  if (value) {
    $addEvent(AnalyticsEvents.SwiperBlockView, {
      chapter: 'product_collection',
      id_chapter: props.data.id,
    });
    unwatch();
  }
}, { immediate: true });
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-home-blocks-selection {
  padding-bottom: 42px;

  @include media-query(lg-and-up) {
    padding-bottom: 82px;
  }

  & + :deep(.osk-home-blocks-list-items) {
    margin-top: -10px;

    .osk-home-blocks-list-items__title {
      display: none;
    }

    @include media-query(lg-and-up) {
      margin-top: -20px;
    }
  }

  &__title {
    @include font-heading;
    padding-bottom: 30px;

    @include media-query(lg-and-up) {
      text-transform: uppercase;
      text-align: center;
      padding-bottom: 34px;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -6px -32px;

    @include media-query(lg-and-up) {
      margin: 0 -12px -62px;
    }
  }

  &__item {
    width: 50%;
    padding: 0 6px;
    margin-bottom: $indent-mlarge;

    @include media-query(sm-and-up) {
      width: 33.333%;
    }

    @include media-query(md-and-up) {
      width: 25%;
    }

    @include media-query(lg-and-up) {
      padding: 0 12px;
      margin-bottom: 62px;
    }
  }
}
</style>
